import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PasswordResetPage from './pages/PasswordResetPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import WeeklyPickSheet from './components/WeeklyPickSheet';
import AdminDashboard from './pages/AdminDashboard';
import UserProfile from './components/UserProfile';
import UserSettingsPage from './pages/UserSettingsPage';
import { AuthContext } from './context/AuthContext';
import LeaderboardPage from './pages/LeaderboardPage';
import PlayoffStatusPage from './pages/PlayoffStatusPage';

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('ProtectedRoute check:', {
      path: location.pathname,
      userExists: !!user,
      user: user,
      passwordResetRequired: user?.passwordResetRequired
    });

    if (!user) {
      console.log('No user found, redirecting to login');
      navigate('/login', { replace: true });
      return;
    }

    if (user?.passwordResetRequired && location.pathname !== '/reset-password') {
      console.log('Password reset required, redirecting');
      navigate('/reset-password', { replace: true });
    }
  }, [user, location.pathname, navigate]);

  if (!user) {
    console.log('ProtectedRoute rendering null - no user');
    return null;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

// Explicitly declare components to satisfy linter
const ProfileComponent = UserProfile;
const SettingsComponent = UserSettingsPage;
const PickSheetComponent = WeeklyPickSheet;

const AppRoutes = () => {
  console.log('AppRoutes rendering');
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<PasswordResetPage />} />

      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/weekly-picks" element={<ProtectedRoute><PickSheetComponent /></ProtectedRoute>} />
      <Route path="/admin-dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/user-profile" element={<ProtectedRoute><ProfileComponent /></ProtectedRoute>} />
      <Route path="/user-settings" element={<ProtectedRoute><SettingsComponent /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />
      <Route path="/playoff" element={<ProtectedRoute><PlayoffStatusPage /></ProtectedRoute>} />

      {/* Catch all route - redirect to home */}
      <Route path="*" element={<ProtectedRoute><Navigate to="/" replace /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;
